module.exports = __webpack_public_path__ + "assets/images/$1c.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/$1c.png
// module id = 68
// module chunks = 1